import CartDiscountCodeForm from './CartDiscountCodeForm';

export default CartDiscountCodeForm;
